import React, { memo, forwardRef } from 'react';

interface MapMarkerLegendProps {
  isPreferred?: boolean;
  isPartnerRateAvailable?: boolean;
  isNoPartnerRateAvailable?: boolean;
}

const MapMarkerLegend = memo(
  forwardRef<HTMLDivElement, MapMarkerLegendProps>(
    (
      {
        isPreferred = false,
        isPartnerRateAvailable = false,
        isNoPartnerRateAvailable = false,
      },
      ref
    ) => (
      <div
        ref={ref}
        className="pointer-events-none bg-white rounded shadow-md p-2 text-xs m-2"
      >
        {isPreferred && (
          <div className="flex items-center">
            <div className="w-3 h-3 rounded-full bg-green-500 mr-2" />
            <span>Preferred Hotel</span>
          </div>
        )}

        {isPartnerRateAvailable && (
          <div className="flex items-center">
            <div className="w-3 h-3 rounded-full bg-yellow-500 mr-2" />
            <span>Partner Rate Available</span>
          </div>
        )}

        {isNoPartnerRateAvailable && (
          <div className="flex items-center">
            <div className="w-3 h-3 rounded-full bg-red-500 mr-2" />
            <span>No Partner Rate Available</span>
          </div>
        )}
      </div>
    )
  )
);

export default MapMarkerLegend;
